<template>
  <div class="container">
    <div class="row mt-5 helper-flex-column-rev" style="width: 100%;">
      <div class="col-lg-5 col-md-12" style="min-width: 44%;">
        <div class="text-center welcome-text">
          <h1 v-if="!tech">{{ $t('signin-form.title')}}</h1>
          <h1 v-else>{{ $t('signin-form.tech-title') }}</h1>
        </div>
        <div class="px-4" v-if="!tech">
          <login-form></login-form>
        </div>
        <div class="px-4" v-else>
          <tech-works :min="min < 10 ? '0'+ min : min" :sec="sec < 10 ? '0'+ sec : sec"></tech-works>
        </div>
        <div class="contacts-wrapper px-4">
          <div>{{$t('signin_contacts')}}</div>
          <div class="item-link"><img width="34px" height="33px" src="images/call-icon.png" alt=""> <a
              href="tel:+77714060878">+7 771 406 0878</a></div>
        </div>
        <div class="intstruction-wrapper px-4">
          <span class="instruction-title">{{$t('signup-by-iin.signin-instruction')}}</span>
          <a v-if="$i18n.locale=='ru'" download href="/files/ru/Инструкция по авторизации 2023.docx.pdf" class="download-instruction">{{ $t('signup-by-iin.download-instruction') }}</a>
          <a v-if="$i18n.locale=='kz'" download href="/files/kz/Авторизациялану_нұсқаулығы_2023_docx.pdf" class="download-instruction">{{ $t('signup-by-iin.download-instruction') }}</a>
          <button  @click="$bvModal.show('youtube-modal-auth')" class="watch-instruction">{{ $t('signup-by-iin.see-instruction') }}</button>
        </div>
        <div class="intstruction-wrapper px-4">
          <span class="instruction-title">{{$t('signup-by-iin.password')}}</span>
          <a v-if="$i18n.locale=='ru'" download href="/files/ru/RU Инструкция по восстановлению пароля ученика 2025.docx.pdf" class="download-instruction">{{ $t('signup-by-iin.download-instruction') }}</a>
          <a v-if="$i18n.locale=='kz'" download href="/files/kz/KZ Оқушының құпия сөздін қалпына келтіру бойынша нұсқаулық 2025.pdf" class="download-instruction">{{ $t('signup-by-iin.download-instruction') }}</a>
          <button  @click="$bvModal.show('youtube-modal-recovery')" class="watch-instruction">{{ $t('signup-by-iin.see-instruction') }}</button>
        </div>
      </div>
      <div style="min-width: 50%; margin-left: auto; padding-top: 100px" class="col-lg-5 col-md-12">
        <div class="intstruction-wrapper" style="overflow-y: auto; max-height: 700px;">
          <img src="/images/IMG_6847.JPG" style="width: 100%; height: auto;" alt="Schedule">
        </div>
      </div>
    </div>
    <b-modal id="youtube-modal-auth" hide-footer hide-header>
      <div >
        <div id="dialog">

          <button @click="$bvModal.hide('youtube-modal-auth')" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <iframe  style="width: 100%; height: 500px;" v-if="$i18n.locale=='kz'"  src="https://www.youtube.com/embed/bZB5FsrBQrI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <iframe  style="width: 100%; height: 500px;" v-else-if="$i18n.locale=='ru'"  src="https://www.youtube.com/embed/pUDS8_XUMmE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </b-modal>

    <b-modal id="youtube-modal-recovery" hide-footer hide-header>
      <div>
        <div id="dialog">
          <button @click="$bvModal.hide('youtube-modal-recovery')" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <iframe  style="width: 100%; height: 500px;" v-if="$i18n.locale=='ru'"  src="https://www.youtube.com/embed/WX7KQ7cksI8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <iframe  style="width: 100%; height: 500px;" v-else-if="$i18n.locale=='kz'"  src="https://www.youtube.com/embed/RYimnQrACYM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import LoginForm from '@/components/LoginForm'
import TechWorks from '@/components/TechWorks'
import pdf from 'vue-pdf';
export default {
  name: 'Login',
  components: {
    LoginForm,
    TechWorks,
    pdf
  },
  data() {
    return {
      min: 0,
      sec: 0,
      totalPageCount: 1,
    }
  },
  computed: {
    ...mapGetters({
      tech: 'isTech',
      time: 'getTime'
    })
  },
  methods: {
    ...mapActions({
      'setTech': 'setTech',
      // 'getTech': 'getTech'
    }),
  },
  watch: {
    sec: {
      handler(value) {
        if(value >= 0) {
          setTimeout(() => {
            this.sec--;
          }, 1000)
        } else if(this.min || this.hour > 0) {
          this.sec = 59;
          if(this.min > 0) {
            this.min--
          }
        }
        if(this.hour === 0 && this.min === 0 && this.sec === 0) {
          setTimeout(() => {
            this.setTech(false)
          }, 1000)
        }
      },
      immediate: true,
    }
  },
  mounted() {
    // this.getTech();
    this.min = this.time
  }
}
</script>
<style lang="css" scoped>

.instruction {
  padding: 30px;
  text-align: center;
  line-height: 1px;
  width: 382px;
  height: 293px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  cursor: pointer;
}

.instruction-subtitle {
  line-height: 19px;
  font-family: Roboto;
  font-size: 13px;
  text-align: center;
  color: #000000;
}

.video {
  display: flex;
  justify-content: center;
  height: 180px;
  width: 287px;
}

.item-link {
  margin-top: 8px;

  img {
    margin-right: 16px;
  }
}

@media screen and (max-width: 991px) {

  .instruction {
    width: 100%;
  }
}

@media screen and (max-width: 575px) {
  .helper-flex-column-rev{
    margin-top: 0!important;
    padding: 0;
    flex-direction: column-reverse;
  }
  .adaptive-wrapper{
    flex-direction: column;
  }
  .iin-input{
    max-width: unset;
  }
  .download-instruction{
    text-align: center;
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }
  .watch-instruction{
    width: 100%;
    margin-left: 0;
  }
  .button-iin-signup-group{
    flex-direction: column;
  }
  .button-iin-next{
    margin-right: 0;
    display: block;
    width: 100%;
  }
  .button-iin-clear{
    margin-bottom: 1rem;
    width: 100%;
    display: block;
  }
  .iin-search-item{
    font-size: 14px;
  }
  .iin-info{
    padding: 10px;
  }
  .warning-message{
    width: 64%;
  }
}
.el-select-dropdown__empty{
  padding: 10px;
}
</style>
